import axios from "axios";
import { toast } from 'react-toastify';

export function exportRecipientsToNetsuite(
    groupOrderId: string, 
    notificationEmail: string
)
{
  return axios
      .post('/.netlify/functions/pushRecipientsToNetsuite-background', {
          orderId: groupOrderId,
          notificationEmail: notificationEmail
      })
      .then(res => {
          toast.success(`Started recipients syncing with Netsuite. Check your email for details.`);
      })
      .catch(err => {
          toast.error(`Error starting syncing with Netsuite.`);
          console.error(err);
      });
}

export default {
    exportRecipientsToNetsuite
}